// components/header/bottom-nav-items.ts

export const navItems = [
  { label: 'All', href: '#' },
  { label: 'Wine Varietal', href: '/collections/wine-varietal', hasDropdown: true },
  { label: 'Wine Region', href: '/collections/wine-region', hasDropdown: true },
  { label: 'Spirits', href: '/collections/spirits', hasDropdown: true, isHot: true },
  { label: 'Sake & Soju', href: '/collections/sake-soju', hasDropdown: true },
  { label: 'Kosher', href: '/collections/kosher-wine' },
  { label: 'Deals', href: '/collections/mega-deals', hasDropdown: true, isHot: true },
  { label: 'Contact & Map', href: '/info/contact' },
];
